var map = {
	"./da-DK.json": 195,
	"./de-DE.json": 196,
	"./en-US.json": 107,
	"./es-419.json": 197,
	"./es-ES.json": 198,
	"./fi-FI.json": 199,
	"./fr-FR.json": 200,
	"./id-ID.json": 201,
	"./it-IT.json": 202,
	"./ja-JP.json": 203,
	"./ko-KR.json": 204,
	"./pt-BR.json": 205,
	"./ro-RO.json": 206,
	"./ru-RU.json": 207,
	"./tr-TR.json": 208,
	"./vi-VN.json": 209,
	"./zh-CN.json": 210
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 194;